"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = void 0;
const schema_1 = require("../../../schema");
const systolicBloodPressure = schema_1.Schema.number()
    .unit("Hgmm")
    .integer()
    .min(40)
    .max(250)
    .interpretation({ vocab: "htx", code: "systolic_blood_pressure" })
    .tag({ vocab: "snomed", code: "271649006" })
    .tag({ vocab: "loinc", code: "8480-6" });
const diastolicBloodPressure = schema_1.Schema.number()
    .unit("Hgmm")
    .integer()
    .min(40)
    .max(251)
    .interpretation({ vocab: "htx", code: "diastolic_blood_pressure" })
    .tag({ vocab: "snomed", code: "271650006" })
    .tag({ vocab: "loinc", code: "8462-4" });
const heartRate = schema_1.Schema.number()
    .unit("/perc")
    .integer()
    .min(30)
    .max(200)
    .interpretation({ vocab: "htx", code: "heart_rate" })
    .tag({ vocab: "snomed", code: "364075005" })
    .tag({ vocab: "loinc", code: "8867-4" });
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ systolicBloodPressure, diastolicBloodPressure, heartRate })
    .tag({ vocab: "snomed", code: "118227000" })
    .tag({ vocab: "snomed", code: "20135006" });
